<template>
  <div class="purchase">
    <div class="title">{{ $t.shopping.quantity }}</div>
    <section class="right">
      <div class="num">1</div>
    </section>
  </div>
</template>
<script>
export default {
  name: "Purchase",
  props: ["inventories"],
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.purchase {
  width: 88%;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  @include publicFlex;
  * {
    margin: 0;
    padding: 0;
  }
  .title {
    font-size: 14px;
    color: #000000;
    background: transparent;
  }
  .right {
    @include publicFlex;
    .num {
      min-width: 40px;
      font-size: 14px;
      color: #000000;
      text-align: center;
    }
  }
}
</style>
